import changelogMarkdown from '../../../../CHANGELOG.md?raw';
import { parseChangelog } from '../utils';

/**
 * Production releases parsed from the repository changelog.
 *
 * The deployed `CHANGELOG.md` is assembled at build time with the candidate
 * release entry prepended to the finalized history, so Vite bundles a single
 * complete file for every environment.
 */
export const changelogReleases = parseChangelog(changelogMarkdown);
